/**
 * **Nur der jüngste Auftrag darf antworten.** `next(fn)` gibt eine Hülle um `fn`, die nur ruft, solange seither
 * kein neuerer Auftrag kam — die Antwort eines überholten verfällt.
 *
 * Für den Abschnitts-Zug (#314, Code-Review): Brauchte das Schreiben länger als die Wartezeit des Zugs, meldete
 * der alte Zug seinen Kopf noch, als schon der nächste wartete, und der „landete“ auf dem falschen.
 *
 * @example
 * const gate = createLatestGate()
 * void handleAddSection(…, gate.next(setDroppedSectionId))
 */
export function createLatestGate() {
  let current = 0
  return {
    next<A extends unknown[]>(fn: (...args: A) => void): (...args: A) => void {
      const token = ++current
      return (...args: A) => {
        if (token === current) fn(...args)
      }
    },
  }
}
